<template>
    <div class="with-inline-website-assistant">
        <input type="hidden" ref="gclid" id="gclid_field" name="gclid_field" value="">
        <website-assistant :inline="true" from="startersets"></website-assistant>
        <section v-if="initialized && this.sets.length" class="starter">
            <div class="pad">
                <div class="wrap">
                    <div class="cards">
                        <div class="card" v-for="(set, setIndex) in sets" :key="'set-' + setIndex">
                            <h3 class="h2">{{ set.name }}</h3>
                            <div class="txt">
                                {{ set.description }}
                            </div>
                            <ul class="sounds-list">
                                <li class="sound" v-for="(jingle, jingleIndex) in visibleJingles(set)" :key="'set-' + setIndex + '-group-' + set.selectedGroup + '-jingle-' + jingleIndex">
                                    <play-button :player-id="'starter-set-' + setIndex + '-jingle-' + jingleIndex + '-group-' + set.selectedGroup" :file-id="jingle.id" :description="jingle.name"></play-button>
                                    <div class="title">{{ jingle.name }}</div>
                                    <player class="starter" :player-id="'starter-set-' + setIndex + '-jingle-' + jingleIndex + '-group-' + set.selectedGroup" :file-id="jingle.id" :totalTime="jingle.duration" wave-form-image-template="frontend_starter"></player>
                                </li>
                            </ul>
                            <div class="season-select" v-if="Object.keys(set.groups).length > 1">
                                <label v-for="(group, groupIndex) in set.groups" :key="'set-' + setIndex + '-group-' + groupIndex + '-select'">
                                    <input type="radio" v-model="set.selectedGroup" @change="clickGroup(group, set)" :value="groupIndex" checked>
                                    <span>{{ group.name }}</span>
                                </label>
                            </div>
                            <div class="btn-box">
                                <a href="#" class="btn" :class="{'disabled': set.region_blocked}" :disabled="set.region_blocked" @click.prevent="selectSet(setIndex)">{{ set.region_blocked ? window.t('starter_set_unavailable') : window.t('starter_pick_set', false, {'setName': set.name})  }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="modal checkout" v-if="checkoutVisible">
			<div class="bg" @click.prevent="toggleCheckout"></div>
            <div class="panel-scroller">
    			<div class="panel">
    				<a href="#" class="close" @click.prevent="toggleCheckout"></a>
    				<form class="form">
    					<div class="modal-head">
    						<h2 class="h2">Pure Starter</h2>
    						<h3 class="h2 black" v-html="checkoutStepDataCol('title')" v-if="!completedOrderId"></h3>
    						<h3 class="h2 black" v-else>{{ window.t('general_work') }}</h3>
    						<div v-html="window.t('starter_header')" class="txt">

                            </div>
    					</div>
    					<div class="modal-body">
    						<div class="step text-centered" v-if="completedOrderId">
                                <template v-if="completedOrderPaid">
                                    <img src="/images/jinglebox-order-complete.svg"><br>
                                    <br>
                                    {{ window.t('starter_thank_you') }}
                                </template>
                                <template v-else v-html="window.t('starter_error')">
                                </template>
                            </div>
    						<div class="step" v-else-if="checkoutStep == 1">
    							<div class="row">
    								<div class="col c5">
    									<div class="fields">
    										<div class="field w100">
    											<input type="text" :placeholder="window.t('form_your_first_name')+'*'" v-model="checkoutData.first_name">
    										</div>
    										<div class="field w100">
    											<input type="text" :placeholder="window.t('form_your_last_name')+'*'" v-model="checkoutData.last_name">
    										</div>
    										<div class="field w100">
    											<input type="email" :placeholder="window.t('form_your_email')+'*'" v-model="checkoutData.email">
    										</div>
    										<div class="field w100">
                                                <select v-model="checkoutData.country_code">
                                                    <option v-for="country in countries" :key="'country-select-' + country.code" :value="country.code">{{ country.name }}</option>
                                                </select>
    										</div>
    										<div class="field w100">
    											<input type="text" :placeholder="window.t('form_your_phone')+'*'" v-model="checkoutData.phone">
    										</div>
											<div class="field w100">
												<input type="text" :placeholder="window.t('form_your_company')" v-model="checkoutData.company">
											</div>
											<div class="field w100" v-if="checkoutData.company != ''">
												<input type="text" :placeholder="window.t('form_your_vat')+'*'" v-model="checkoutData.vat_number">
											</div>
    										<div class="field w100">
    											<input type="text" :placeholder="window.t('form_your_station')+'*'" v-model="checkoutData.radio_station">
    										</div>
    										<div class="field w100">
    											<input type="text" :placeholder="window.t('form_your_area')+'*'" v-model="checkoutData.broadcast_region">
    										</div>
    									</div>
    								</div>
    								<div class="col c6 o1">
    									<div class="fields">
    										<div class="field w100">
    											{{ window.t('starter_add_drones') }}
                                                <div class="extra_option_price">(+ € {{checkoutData.starter_set_add_on_price}})</div>
    											<div class="inline-radios">
    												<label>
    													<input type="radio" :value="1" v-model="checkoutData.bed_and_drones"> {{ window.t('general_yes') }}
    												</label>
    												<label>
    													<input type="radio" :value="0" v-model="checkoutData.bed_and_drones"> {{ window.t('general_no') }}
    												</label>
    											</div>
    										</div>
    										<div class="field w100" v-for="(group, groupIndex) in optionalGroups" :key="'optional-groups-' + groupIndex + '-selected-set-' + selectedSetIndex">
                                                {{ window.t('starter_add_versions', false, {'groupName': group.name}) }}
                                                <div class="extra_option_price">(+ € {{checkoutData.starter_set_add_on_price}})</div>
    											<div class="inline-radios">
    												<label>
    													<input type="radio" :value="1" v-model="checkoutData.set_options[group.id]"> {{ window.t('general_yes') }}
    												</label>
    												<label>
    													<input type="radio" :value="0" v-model="checkoutData.set_options[group.id]"> {{ window.t('general_no') }}
    												</label>
    											</div>
    										</div>
    										<div class="field w100">
    											{{ window.t('starter_add_voiceover') }}
                                                <div class="extra_option_price">(+ € {{checkoutData.starter_set_add_on_price}} and optional VO fee)</div>
    											<div class="inline-radios">
    												<label>
    													<input type="radio" :value="1" v-model="checkoutData.voiceover_inserts"> {{ window.t('general_yes') }}
    												</label>
    												<label>
    													<input type="radio" :value="0" v-model="checkoutData.voiceover_inserts"> {{ window.t('general_no') }}
    												</label>
    											</div>
    										</div>
                                        </div>
    								</div>
    							</div>
    						</div>
    						<div class="step" v-else-if="checkoutStep == 2">
    							<div class="row">
    								<div class="col c5">
    									<div class="fields">
    										<div class="field w100">
    											{{ window.t('form_question_logo') }}
    											<div class="inline-radios">
    												<label>
    													<input type="radio" :value="1" v-model="checkoutData.has_audio_logo"> {{ window.t('general_yes') }}
    												</label>
    												<label>
    													<input type="radio" :value="0" v-model="checkoutData.has_audio_logo"> {{ window.t('general_no') }}
    												</label>
    											</div>
    										</div>
    										<div class="field w100" v-if="checkoutData.has_audio_logo">
                                                {{ window.t('form_question_free_of_rights') }}
    											<div class="inline-radios">
    												<label>
    													<input type="radio" :value="1" v-model="checkoutData.audio_logo_is_free_of_rights"> {{ window.t('general_yes') }}
    												</label>
    												<label>
    													<input type="radio" :value="0" v-model="checkoutData.audio_logo_is_free_of_rights"> {{ window.t('general_no') }}
    												</label>
    											</div>
    										</div>
    									</div>
    								</div>
    								<div class="col c6 o1" v-if="checkoutData.has_audio_logo">
                                        <audio-uploader :value.sync="checkoutData.audio_file" :upload-text="window.t('general_upload_logo')"></audio-uploader>
    								</div>
    							</div>
    						</div>
    						<div class="step" v-else-if="checkoutStep == 3">
                                <div class="recorder-box">
                                    <div class="txt">
                                        {{ window.t('starter_upload_pronunciation') }}
                                    </div>
                                    <div class="options">
                                        <audio-uploader class="option" :value.sync="checkoutData.pronunciation_file" compact></audio-uploader>
                                        <audio-recorder class="option" :value.sync="checkoutData.pronunciation_recording"></audio-recorder>
                                    </div>
                                </div>
    						</div>
    						<div class="step" v-else-if="checkoutStep == 4">
    							<h3 class="h5 black mb1">{{ window.t('form_check') }}</h3>
								<div v-html="window.t('form_check_body')" class="txt"></div>
    							<br>
    							<br>
    							<div class="row">
    								<div class="col c4">
    									<h4 class="h6 pink mb05">{{ window.t('general_general') }}</h4>
    									<div class="txt">
    										{{ checkoutData.first_name }} {{ checkoutData.last_name }}<br>
    										{{ checkoutData.email }}<br>
    										{{ selectedCountryName }}<br>
    										{{ checkoutData.phone }}<br>
    										<template v-if="checkoutData.company">{{ checkoutData.company }}<br></template>
    										<template v-if="checkoutData.vat_number">{{ checkoutData.vat_number }}<br></template>
    										{{ checkoutData.radio_station }}<br>
    										{{ checkoutData.broadcast_region }}<br>
    									</div>
    								</div>
    								<div class="col c4">
    									<h4 class="h6 pink mb05">{{ window.t('general_audio_logo') }}</h4>
    									<div class="txt">
    										{{ checkoutData.has_audio_logo ? window.t('general_existing_logo') : window.t('general_non_existing_logo') }}<br>
    										{{ checkoutData.has_audio_logo ? (checkoutData.audio_logo_is_free_of_rights ? window.t('general_free_of_rights') : window.t('general_not_free_of_rights')) : '' }}<br>
                                            <play-button  player-id="jinglebox-checkout-audio-logo" v-if="checkoutData.audio_file" :file-url="'/files/' + checkoutData.audio_file" :use-label="window.t('general_audio_logo_example')" class-name="" description="Starter set - Audio logo"></play-button>
                                            <player v-if="checkoutData.audio_file" player-id="jinglebox-checkout-audio-logo" :file-url="'/files/' + checkoutData.audio_file"></player>
    									</div>
    								</div>
    								<div class="col c4">
    									<h4 class="h6 pink mb05">{{ window.t('general_production') }}</h4>
    									<div class="txt">
                                            <template v-if="checkoutData.pronunciation_file || checkoutData.pronunciation_recording">
                                                <play-button  player-id="jinglebox-checkout-pronunciation-file" v-if="checkoutData.pronunciation_file" :file-url="'/files/' + checkoutData.pronunciation_file" use-label="Pronunciation example" class-name="" description="Starter set - Pronunciation file"></play-button>
                                                <player v-if="checkoutData.pronunciation_file" player-id="jinglebox-checkout-pronunciation-file" :file-url="'/files/' + checkoutData.pronunciation_file"></player>
                                                <a href="#" v-if="checkoutData.pronunciation_recording" @click.prevent="pronunciationRecordingPlay">Pronunciation example (Recording)</a>
                                            </template>
                                            <template v-else>
                                                {{ window.t('general_not_provided') }}
                                            </template>
    									</div>
    								</div>
    								<div class="col c4">
    									<h4 class="h6 pink mb05">{{ window.t('general_order') }}</h4>
    									<div class="txt">
                                            <div>Base package &euro; {{checkoutData.starter_set_price}}</div>
                                            <div v-if="checkoutData.bed_and_drones">+ Beds &amp; Drones &euro;&nbsp;{{checkoutData.starter_set_add_on_price}}</div>
                                            <div v-for="(selectedOptionalGroup, selectedOptionalGroupIndex) in selectedOptionalGroups" :key="'selected-optional-groups-' + selectedOptionalGroupIndex + '-selected-set-' + selectedSetIndex">+ {{ selectedOptionalGroup.name }} versions &euro;&nbsp;{{checkoutData.starter_set_add_on_price}}</div>
                                            <div v-if="checkoutData.voiceover_inserts">+ Voiceover inserts &euro;&nbsp;{{checkoutData.starter_set_add_on_price}}</div>
                                            <div>{{ window.t('general_vat') }} ({{ vatRateForOrder }}%): &euro; {{ vatAmountForOrder }}</div>
                                            <div>{{ window.t('general_total') }}: &euro; {{ totalForOrderIncludingVat }}</div>
    									</div>
    								</div>
    							</div>
                                <br>
                                <br>
                                <div class="row">
                                    <div class="col c12">
                                        <br>
                                        <div class="checkbox-wrap">
                                            <input v-model="checkoutData.consent" :value="true" data-hj-allow class="brown" type="checkbox" id="terms" name="terms">
                                            <label class="checkbox-label" for="terms">{{ window.t('form_consent_body') }}</label>
                                        </div>
                                    </div>
                                </div>
    						</div>
    					</div>
    					<div class="modal-foot">
    						<a href="#" :class="['btn', 'w180', {hidden: checkoutStep == 1}]" @click.prevent="checkoutPrev" v-if="!completedOrderId">Prev<span class="full">ious step</span></a>
                            <div class="progress" v-if="!completedOrderId">
                                <span class="full">Step</span> {{ checkoutStep }} of {{ maxStep }}
    						</div>
                            <div v-else>&nbsp;</div>
    						<a v-if="!completedOrderId" href="#" :class="['btn', 'w180', {disabled: !nextStepAvailable}]" @click.prevent="checkoutNext" v-html="(checkoutStep == maxStep ? 'Place order' : 'Next<span class=\'full\'>&nbsp;step</span>')"></a>
    					</div>
    				</form>
    			</div>
            </div>
		</section>
    </div>
</template>


<script>

    export default {
        props: {
            defaultLanguage: {
                type: String,
                default: 'en',
            },
            language: {
                type: String,
                default: 'en',
            },
            url: {
                type: String,
                required: true,
            }
        },
        data() {
            return {
                window,
                initialized: false,
                sets: [],
                selectedSetIndex: null,
                checkoutVisible: false,
                checkoutStep: 1,
                checkoutStepData: {
                    1: {
                        title: 'General',
                    },
                    2: {
                        title: 'Audio logo',
                    },
                    3: {
                        title: 'Production',
                    },
                    4: {
                        title: 'Overview',
                    },
                },
                checkoutData: {},
                completedOrderId: null,
                completedOrderPaid: false,
                countries: [],
                vatValid: false,
            }
        },
        watch: {
            sets: {
                handler() {
                    if (this.initialized) {
                        this.$root.$emit('audioElementReset');
                    }
                },
                deep: true
            },
        },
        methods: {
            clickGroup(group,set) {
                    _gte('click', {
                        'event_category': 'Starter',
                        'event_label':  group.name + ' - ' + set.name,
                    });
                console.log(group.name);
            },
            selectSet(setIndex) {
                const set = this.sets[setIndex] || null;

                if (!set || set.region_blocked) {
                    return;
                }

                this.selectedSetIndex = setIndex;
                this.initCheckoutData();
                this.toggleCheckout();

                _gte('click', {
                    'event_category': 'Starter',
                    'event_label': window.t('starter_pick_set', false, {'setName': this.sets[this.selectedSetIndex].name}),
                });
            },
            pronunciationRecordingPlay() {
                if (this.checkoutData.pronunciation_recording) {
                    const audioUrl = URL.createObjectURL(this.checkoutData.pronunciation_recording);
                    const audio = new Audio(audioUrl);
                    audio.play();
                }

                return false;
            },
            initCheckoutData() {
                let setOptions = {};

                for (let g in this.sets[this.selectedSetIndex].groups) {
                    if (this.sets[this.selectedSetIndex].groups[g].id && !this.sets[this.selectedSetIndex].groups[g].isMain) {
                        setOptions[this.sets[this.selectedSetIndex].groups[g].id] = null;
                    }
                }

                this.checkoutData = {
                    starter_sets_url: this.url,
                    starter_set_id: this.sets[this.selectedSetIndex].id,
                    starter_set_price: this.sets[this.selectedSetIndex].price,
                    starter_set_add_on_price: this.sets[this.selectedSetIndex].add_on_price,
                    first_name: '',
                    last_name: '',
                    email: '',
                    country_code: 'nl',
                    phone: '',
                    company: '',
                    vat_number: '',
                    radio_station: '',
                    broadcast_region: '',
                    bed_and_drones: null,
                    voiceover_inserts: null,
                    set_options: setOptions,
                    has_audio_logo: null,
                    audio_logo_is_free_of_rights: null,
                    audio_file: '',
                    pronunciation_file: '',
                    pronunciation_recording: '',
                    consent: false,
                };
            },
            toggleCheckout() {
                this.checkoutVisible = !this.checkoutVisible;
                $html.toggleClass('modal-visible');

                if (!this.checkoutVisible) {
                    this.checkoutStep = 1;
                    this.completedOrderId = null;
                }
            },
            checkoutStepDataCol(col) {
                if (this.checkoutStepData[this.checkoutStep][col]) {
                    return this.checkoutStepData[this.checkoutStep][col];
                }

                return '';
            },
            checkoutPrev() {
                if (this.checkoutStep > 1) {
                    this.checkoutStep--;
                }
            },
            isEuCountry(countryCode) {
                for (let c in this.countries) {
                    if (this.countries[c].code == countryCode) {
                        return this.countries[c].eu;
                    }
                }

                return false;
            },
            vatRateForCountry(countryCode) {
                for (let c in this.countries) {
                    if (this.countries[c].code == countryCode) {
                        return this.countries[c].rate;
                    }
                }

                return false;
            },
            checkoutNext: async function() {

                if (this.nextStepAvailable) {
                    if (this.checkoutStep < this.maxStep) {
                        if (this.checkoutStep == 1) {
                            this.vatValid = false;
                        }
                        if (this.checkoutStep == 1 && this.checkoutData.vat_number != '' && this.isEuCountry(this.checkoutData.country_code)) {
                            await axios
                                .post('/validate-vat', {vat_number: this.checkoutData.vat_number, country_code: this.checkoutData.country_code})
                                .then((response) => {
                                    if (!response.data.success) {
                                        this.vatValid = false;
                                        alert('Invalid VAT number');
                                    } else {
                                        this.vatValid = true;
                                        this.checkoutStep++;
                                    }
                                })
                        } else {
                            this.checkoutStep++;
                        }
                    } else {
                        if (! await this.submit()) {
                            alert(window.t('form_error'));
                        }
                    }
                }
            },
            submit: async function() {

                let validated = false;

                const config = {
                    header : {
                        'Content-Type' : 'multipart/form-data'
                    }
                };

                const formData = new FormData();
                const checkoutDataProperties = Object.getOwnPropertyNames(this.checkoutData)

                if (this.$refs.gclid) {
                    formData.append('gclid', this.$refs.gclid.value);
                }

                for (var k in checkoutDataProperties) {
                    if (checkoutDataProperties[k] == 'audio_logo_is_free_of_rights' && this.checkoutData.has_audio_logo == 0) {
                        formData.append(checkoutDataProperties[k], 0);
                        continue;
                    }

                    let useValue = this.checkoutData[checkoutDataProperties[k]];

                    if (checkoutDataProperties[k] == 'set_options') {
                        formData.append(checkoutDataProperties[k], JSON.stringify(useValue));
                        continue;
                    }

                    if (k == 'pronunciation_recording' || k == 'inspiration_recording') {
                        if (this.checkoutData[checkoutDataProperties[k]]) {
                            let extension = this.checkoutData[checkoutDataProperties[k]].type.split('/')[1];
                            useValue = new File([this.checkoutData[checkoutDataProperties[k]]], `${Date.now()}.${extension}`, {
                                type: this.checkoutData[checkoutDataProperties[k]].type,
                            });
                        }
                    }

                    formData.append(checkoutDataProperties[k], useValue);
                }

                await axios
                    .post((this.language != this.defaultLanguage ? '/' + this.language : '') + '/starter-sets/validate-checkout', formData, config)
                    .then((response) => {
                        if (response.data.hasOwnProperty('redirect_url')) {
                            validated = true;
                            document.location = response.data.redirect_url;
                        }
                    })
                    .catch(() => {

                    });

                return validated;

            },
            visibleJingles(set) {
                return set.groups[set.selectedGroup].jingles;
            },
            fetchData: async function() {
                const postData = {
                    initialized: this.initialized,
                };

                if (this.$route.query['starter-set-order-complete']) {
                    postData['starter-set-order-complete'] = this.$route.query['starter-set-order-complete'];
                }

                await axios
                    .post((this.language != this.defaultLanguage ? '/' + this.language : '') + '/starter-sets/init', postData)
                    .then((response) => {
                        if (response.data.hasOwnProperty('sets')) {
                            const sets = response.data.sets;

                            for (let s in sets) {
                                sets[s].selectedGroup = Object.keys(sets[s].groups)[0];

                                for (let g in sets[s].groups) {
                                    if (sets[s].groups[g].isMain) {
                                        sets[s].selectedGroup = g;
                                    }
                                }
                            }

                            this.sets = sets;
                        }

                        if (response.data.hasOwnProperty('orderId')) {
                            this.completedOrderId = response.data.orderId;
                        }

                        if (response.data.hasOwnProperty('orderPaid')) {
                            this.completedOrderPaid = response.data.orderPaid;
                        }

                        if (response.data.hasOwnProperty('countries')) {
                            this.countries = response.data.countries;
                        }
                    })
                    .catch(() => {

                    });

                this.initialized = true;
            },
            validateEmail(value) {
               return /\S+@\S+\.\S+/.test(value);
            },
            downloadOrderZip() {
                if (!this.completedOrderId || !this.completedOrderPaid) {
                    return false;
                }

                document.location = '/starter-sets/download/' + this.completedOrderId;
            }
        },
        computed: {
            selectedCountryName() {
                for (let c in this.countries) {
                    if (this.countries[c].code == this.checkoutData.country_code) {
                        return this.countries[c].name;
                    }
                }

                return '';
            },
            nextStepAvailable() {
                if (this.checkoutStep == 1) {
                    if (this.checkoutData.company && !this.checkoutData.vat_number) {
                        return false;
                    }
                    if (this.checkoutData.first_name.trim() != '' && this.checkoutData.last_name.trim() != '' && this.checkoutData.email.trim() != '' && this.validateEmail(this.checkoutData.email) && this.checkoutData.phone.trim() != '' && this.checkoutData.radio_station.trim() != '' && this.checkoutData.broadcast_region.trim() != '' && this.checkoutData.bed_and_drones != null && this.checkoutData.voiceover_inserts != null) {
                        for (let o in this.checkoutData.set_options) {
                            if (this.checkoutData.set_options[o] == null) {
                                return false;
                            }
                        }

                        return true;
                    }
                } else if (this.checkoutStep == 2) {
                    if (this.checkoutData.has_audio_logo != null) {
                        if (this.checkoutData.has_audio_logo) {
                            return this.checkoutData.audio_logo_is_free_of_rights != null;
                        }

                        return true;
                    }
                } else if (this.checkoutStep == 3) {
                    return true;
                } else if (this.checkoutStep == 4) {
                    if (this.checkoutData.consent) {
                        return true;
                    }
                }

                return false;
            },
            optionalGroups() {
                const optionalGroups = [];

                if (this.selectedSetIndex == null) {
                    return optionalGroups;
                }

                for (let g in this.sets[this.selectedSetIndex].groups) {
                    if (this.sets[this.selectedSetIndex].groups[g].isMain) {
                        continue;
                    }

                    optionalGroups.push(this.sets[this.selectedSetIndex].groups[g]);
                }

                return optionalGroups;
            },
            selectedOptionalGroups() {
                const selectedOptionalGroups = [];

                if (this.selectedSetIndex == null) {
                    return selectedOptionalGroups;
                }

                for (let o in this.optionalGroups) {
                    if (this.checkoutData.set_options[this.optionalGroups[o].id] == 1) {
                        selectedOptionalGroups.push(this.optionalGroups[o]);
                    }
                }

                return selectedOptionalGroups;
            },
            maxStep() {
                return Math.max.apply(null,Object.keys(this.checkoutStepData));
            },
            vatRateForOrder() {
                return this.vatValid ? 0 : this.vatRateForCountry(this.checkoutData.country_code);
            },
            totalForOrder() {
                let total = this.checkoutData.starter_set_price;

                if (this.checkoutData.bed_and_drones) {
                    total += this.checkoutData.starter_set_add_on_price;
                }

                if (this.checkoutData.voiceover_inserts) {
                    total += this.checkoutData.starter_set_add_on_price;
                }

                for (let s in this.selectedOptionalGroups) {
                    total += this.checkoutData.starter_set_add_on_price;
                }

                return total;
            },
            vatAmountForOrder() {
                const total = this.totalForOrder;

                return total * (this.vatRateForOrder/100);
            },
            totalForOrderIncludingVat() {
                return this.totalForOrder + this.vatAmountForOrder;
            }
        },
        mounted: async function() {
            await this.fetchData();

            if (this.completedOrderId) {
                this.checkoutVisible = true;

                $html.addClass('modal-visible');
            }
        },
    }
</script>
